import { Card, ModalV2 as Modal } from '@utilities';

import { SCREENER_QUESTION_TYPES } from './utilities/constants';

import styles from './_index.module.scss';

interface ModalScreenerQuestionProps {
  onClose: () => void;
}

const ModalScreenerQuestion = ({ onClose }: ModalScreenerQuestionProps) => {
  return (
    <Modal buttons={[]} isActive onClose={onClose} size="large" title="Add Screener Question">
      <div className={styles['modal-screener-question-grid']}>
        {SCREENER_QUESTION_TYPES.map(({ description, title }) => (
          <Card className={styles['modal-screener-question-card']} key={title} padding="large">
            <span className={styles['modal-screener-question-card-title']}>{title}</span>
            <span className={styles['modal-screener-question-card-description']}>
              {description}
            </span>
          </Card>
        ))}
      </div>
    </Modal>
  );
};

export default ModalScreenerQuestion;
